var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-badge',{attrs:{"color":_vm.color,"content":_vm.content,"inline":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }